/* Shared form helpers extracted from Dashboard.jsx so they can be used from
   both the main dashboard tree and split-out section files (SetupSection etc.)
   without a circular import. */
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Slider } from "@/components/ui/slider";

export function Field({ label, value, onChange, testId, placeholder, type = "text" }) {
  return (
    <div className="space-y-1.5">
      <Label className="overline">{label}</Label>
      <Input
        data-testid={testId}
        type={type}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        className="bg-white border-slate-200 mono h-10"
      />
    </div>
  );
}

export function ToggleRow({ label, desc, checked, onChange, testId }) {
  return (
    <div className="flex items-center justify-between py-2">
      <div className="pr-3">
        <p className="text-sm font-medium">{label}</p>
        <p className="text-xs text-slate-500">{desc}</p>
      </div>
      <Switch data-testid={testId} checked={checked} onCheckedChange={onChange}
              className="data-[state=checked]:bg-[#4F46E5]" />
    </div>
  );
}

export function SliderRow({ label, value, onValueChange, min, max, step, testId }) {
  return (
    <div className="space-y-2 pt-1">
      <Label className="overline">{label}</Label>
      <Slider data-testid={testId} value={value} onValueChange={onValueChange}
              min={min} max={max} step={step} className="w-full" />
    </div>
  );
}
